<template>
<div class="container-fluid" style="margin-left:0;padding-left:1.5rem;width:100%">
      <header class="d-flex justify-content-between align-items-center py-3 border-bottom">
      <!-- 왼쪽 정렬: 김프모아 -->
      <a href="/" class="navbar-brand d-flex align-items-center text-dark text-decoration-none">
        <h3 class="mb-0" style="color:#60666b;font-family: 'Noto Sans KR', sans-serif; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);font-weight: bold;">김프모아</h3>
      </a>

    <!-- 모바일에서는 햄버거 메뉴로 숨겨지고 데스크탑에서는 오른쪽에 메뉴 배치 -->
    <ul class="nav nav-pills d-none d-md-flex">
      <li class="nav-item"><a href="/" class="nav-link" style="color:#60666b" aria-current="page">HOME</a></li>
      <li class="nav-item"><a href="/SystemSetup" class="nav-link" aria-current="page" style="color: #60666b;">SETTING</a></li>
      <li class="nav-item"><a href="/Guide" class="nav-link" aria-current="page" style="color: #60666b;">GUIDE</a></li>
    </ul>

    <!-- 모바일 햄버거 메뉴 -->
    <button class="navbar-toggler d-md-none ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span></span>
      <span></span>
      <span></span>
    </button>
    <!--
     <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    -->
    

    <!--
        <ul class="nav nav-pills">
          <li class="nav-item"><a href="#" class="nav-link active" aria-current="page">코인</a></li>
          <li class="nav-item"><a href="#" class="nav-link" aria-current="page">미국주식</a></li>
          
          <li class="nav-item"><a href="#" class="nav-link">설정</a></li>
          
          <li class="nav-item"><a href="#" class="nav-link" style="color:#60666b">About</a></li>
          
        </ul>
        -->
      </header>
      <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav" style="text-align: right;">
        <li class="nav-item" style="color:#60666b">
          <a class="nav-link" aria-current="page" href="/">HOME</a>
        </li>
        <li class="nav-item" style="color:#60666b">
          <a class="nav-link" href="/SystemSetup">SETTING</a>
        </li>
        <li class="nav-item" style="color:#60666b">
          <a class="nav-link" href="/Guide">GUIDE</a>
        </li>
        <!--
        <li class="nav-item">
          <a class="nav-link disabled">Disabled</a>
        </li>
        -->
      </ul>
    </div>
    </div>
    <div class="info-bar" style="display: flex; align-items: center; gap: 30px;height:40px">
    </div>

  <div class="container">
    <!-- 제목과 작성일 -->
    <div class="row">
      <div class="col-12">
        <h1 class="display-4">김치 프리미엄이란..</h1>
      </div>
    </div>

     <!-- 이미지 -->
      <div class="row">
        <div class="col-12">
          <img src="https://via.placeholder.com/800x400" alt="Post Image" class="img-fluid rounded mb-4">
        </div>
      </div>

      <!-- 내용 -->
      <div class="row" style="text-align:left;">
        <div class="col-12">
          <p class="lead">11111111111</p>
        </div>
      </div>

    <!-- 관련 링크 -->
    <div class="row mt-4">
      <div class="col-12">
        <h5>관련 링크</h5>
        <ul class="list-group">
          <li class="list-group-item">
            <a href="/Info1" class="text-dark">김프매매/펀비매매 하는법</a>
          </li>
          <li class="list-group-item">
            <a href="/Info2" class="text-dark">김치 프리미엄이란..</a>
          </li>
          <li class="list-group-item">
            <a href="/Info3" class="text-dark">토탈차트 뜻</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="bg-dark text-white text-center py-1 fixed-bottom" style="font-size:0.8rem">
     Copyright © 2025 kimpmoa. All Rights Reserved.
    <br>
    <a href="/PrivacyPolicy" class="text-white mx-2" style="font-size:0.7rem">개인정보처리방침</a> |
    <a href="/TermsOfService" class="text-white mx-2" style="font-size:0.7rem">이용약관</a> |
    <a href="/about" class="text-white mx-2" style="font-size:0.7rem">사이트소개</a>
    </div>
</template>

<script>
export default {
  name: "IntroPage"
};
</script>

<style scoped>

.fixed-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.fs-4 {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  align-items: center;
  align-content: space-between;
  justify-content: center;
}
.align-left{
  text-align: left;
  font-size: 0.8rem;
  vertical-align: middle;
  white-space: nowrap;
}
.align-right{
  text-align: right;
  font-size: 0.8rem;
  vertical-align: middle;
  white-space: nowrap;
}
.p0{  
    padding: 0.3rem 0 0.3rem 0;
}
.bongStyle{
  border: 1px solid #60666b;font-size:0.8rem;
}
.bongSelect{
  background-color: #A6A6A6;
}
.index-search {
  width:100%;
  border:var(--bs-border-width) solid var(--bs-highlight-color);
}
.btn-outline-dark {
    --bs-btn-color: #000;;
    --bs-btn-border-color: #60666b;;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #60666b;;
    --bs-btn-hover-border-color: #60666b;;
    --bs-btn-focus-shadow-rgb: 33, 37, 41;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #60666b;;
    --bs-btn-active-border-color: #60666b;;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #60666b;;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #60666b;;
    --bs-gradient: none;
}
.nav-pills {
    --bs-nav-pills-border-radius: var(--bs-border-radius);
    --bs-nav-pills-link-active-color: #fff;
    --bs-nav-pills-link-active-bg: #60666b;
}
.nav {
    --bs-nav-link-padding-x: 1rem;
    --bs-nav-link-padding-y: 0.5rem;
    --bs-nav-link-font-weight: ;
    --bs-nav-link-color: #60666b;
    --bs-nav-link-hover-color: #60666b;
    --bs-nav-link-disabled-color: var(--bs-secondary-color);
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
}
.cursor-pointer{
   cursor: pointer;
}
.info-bar {
    background-color: black;
    color: white;
    text-align: center;
    padding: 10px 0;
    font-size: 16px;
    position: sticky;
    top: 0;
    z-index: 1020; /* 네비게이션 바 위에 배치 */
}

/* 내용이 가려지지 않도록 패딩 추가 */
.row {
    padding-top: 30px; /* 네비게이션 바 + 정보 바 높이만큼 여백 */
}
.navbar-toggler {
  width: 25px;
  height: 22px;
  background: none;
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.navbar-toggler span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: #adb5bd;
  border-radius: 2px;
  transition: all 0.3s ease-in-out;
}
.card {
  border: none;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease;
}
.card:hover {
  transform: translateY(-10px);
}
.card-img-top {
  height: 200px;
  object-fit: cover;
}
.card-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
}
.card-text {
  font-size: 0.9rem;
  color: #6c757d;
}

/* 버튼 스타일 */
.btn {
  background-color: #60666b;
  color: white;
  border-radius: 20px;
  font-size: 0.8rem;
  transition: background-color 0.3s ease;
}
.btn:hover {
  background-color: #505759;
}

/* 레이아웃 설정 */
.container {
  max-width: 800px; /* 최대 너비를 설정 */
  margin-left: auto; /* 좌측 여백 자동 */
  margin-right: auto; /* 우측 여백 자동 */
}
.row {
  margin-bottom: 50px;
}

/* Footer 스타일 */
.bg-dark {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 10;
}
.text-white {
  color: white;
}
</style>
